import TemplateView from '../../TemplateView'
import CommentsList from './CommentsList'
import LoadMoreCommentsButton from "./LoadMoreCommentsButton"
import {COMMENTS_SCROLL_TO} from './constants'
import ScrollUtils from '../../util/ScrollUtils'
import LoadingContainer from '../../util/LoadingContainer'
import messageResource from '../../messageResource'
import {getInstance as getTooltipInstance} from '../../SimpleSingletonTooltip'

export default class CommentsSection extends TemplateView {
    constructor({
        startEditComment = (id) => {},
        cancelEditComment = () => {},
        updateEditingCommentText = (text) => {},
        saveEditingComment = () => {},
        deleteComment = id => {},
        loadMoreComments = () => {},
        changeCommentsOrder = () => {},
        resetCommentsScrollTo = () => {},
        refreshScrollCb = () => {},
        scrollToElementCb = () => {},
    }) {
        super()

        this.state = {
            loggedInUser: null,
            users: {},
            comments: [],
            commentsCount: 0,
            allCommentsUserIds: [],
            loading: false,
            isNewCommentsOnTop: false,
            recentlyAddedCommentsIds: {},
            commentsScrollTo: null,
            editingCommentId: null,
            editingCommentText: '',
            updatingCommentId: null,
            readOnly: false,
            canManage: false,
        }

        this.actions = {
            startEditComment,
            cancelEditComment,
            updateEditingCommentText,
            saveEditingComment,
            deleteComment,
            loadMoreComments,
            changeCommentsOrder,
            resetCommentsScrollTo,
        }

        this.callbacks = {
            refreshScrollCb,
            scrollToElementCb,
        }

        this.onStatePropertyChanged('loggedInUser', loggedInUser => this.commentsList.setState({loggedInUser}))

        this.onAnyStatePropertyChanged(['users', 'comments', 'allCommentsUserIds'], () => {
            this.commentsList.setState({
                users: this.state.users,
                comments: this.state.comments,
                allCommentsUserIds: this.state.allCommentsUserIds,
            })

            this.loadMoreButton.toggle(this.state.commentsCount > this.state.comments.length)
            this.callbacks.refreshScrollCb()
        })

        this.onStatePropertyChanged('isNewCommentsOnTop', isNewCommentsOnTop => {
            this.$commentsListContainer.toggleClass('orderReversed', !isNewCommentsOnTop)
            this.$orderButton.toggleClass('desc', !isNewCommentsOnTop)
            this.commentsList.setState({isNewCommentsOnTop})

            this.unsubscribeOrderButtonTooltip && this.unsubscribeOrderButtonTooltip()
            this.unsubscribeOrderButtonTooltip = getTooltipInstance().subscribeToMouseEvents(
                this.$orderButton,
                this._updateOrderButtonTooltipStateHandler
            )
            this._updateOrderButtonTooltipStateHandler()
        })

        this.onStatePropertyChanged('commentsCount', commentsCount => {
            this.commentsCount.text('(' + commentsCount + ')')
            this.$orderButton.toggle(commentsCount > 1)
        })

        this.onStatePropertyChanged('recentlyAddedCommentsIds', recentlyAddedCommentsIds => {
            this.commentsList.setState({recentlyAddedCommentsIds})
        })

        this.onStatePropertyChanged('updatingCommentId', updatingCommentId => {
            this.commentsList.setState({updatingCommentId})
            this.commentsListWrapper.setState({loading: updatingCommentId !== null})
        })

        this.onStatePropertyChanged('loading', loading => this.loadMoreButton.setState({loading}))
        this.onStatePropertyChanged('commentsScrollTo', commentsScrollTo => this._scrollToLoadedComments(commentsScrollTo))

        this.onStatePropertyChanged('editingCommentId', editingCommentId => this.commentsList.setState({editingCommentId}))
        this.onStatePropertyChanged('editingCommentText', editingCommentText => this.commentsList.setState({editingCommentText}))
        this.onStatePropertyChanged('readOnly', readOnly => this.commentsList.setState({readOnly}))
        this.onStatePropertyChanged('canManage', canManage => this.commentsList.setState({canManage}))
    }

    templateHtml() {
        return "<div class='commentsSection section'>" +
               "    <div class='sectionHeader'>" +
               "        <span><%=header%></span>" +
               "        <span class='commentsCount'/>" +
               "        <div class='orderButton'/>" +
               "    </div>" +
               "    <div class='commentsListContainer'/>" +
               "</div>";
    }

    messageKeys() {
        return {
            header: "panel.common.comments.header"
        }
    }

    afterRender() {
        this.commentsCount = this.find('.commentsCount')
        this.$commentsListContainer = this.find('.commentsListContainer')
        this.commentsList = new CommentsList({
            startEditComment: this.actions.startEditComment,
            cancelEditComment: this.actions.cancelEditComment,
            updateEditingCommentText: this.actions.updateEditingCommentText,
            saveEditingComment: this.actions.saveEditingComment,
            onCommentDeleted: this.actions.deleteComment,
            refreshScrollCb: this.callbacks.refreshScrollCb,
        })

        this.commentsListWrapper = new LoadingContainer({
            containerClass: 'commentsListLoadingWrapper',
            contentComponent: this.commentsList
        }).init(this.$commentsListContainer)
        this.loadMoreButton = new LoadMoreCommentsButton({
            onClickCb: this.actions.loadMoreComments
        }).init(this.$commentsListContainer)

        this.loadMoreButton.hide()

        this.$orderButton = this.find('.orderButton')
        this.$orderButton.on('click', () => {
            this.actions.changeCommentsOrder(!this.state.isNewCommentsOnTop)
        })
    }

    _updateOrderButtonTooltipStateHandler = () => {
        const orderButtonTooltipKey = this.state.isNewCommentsOnTop ? 'panel.common.comments.order_button.tooltip.newest_top' : 'panel.common.comments.order_button.tooltip.oldest_top'
        getTooltipInstance().setState({
            text: messageResource.getMessage(orderButtonTooltipKey),
            extraClass: '',
        })
    }

    _scrollToLoadedComments(scrollTo) {
        if (scrollTo === COMMENTS_SCROLL_TO.RECENTLY_ADDED) {
            !this.state.isNewCommentsOnTop ? this._scrollToCommentsSectionBottom() : this._scrollToCommentsSectionTop()
        } else if (scrollTo === COMMENTS_SCROLL_TO.LOADED_OLDER) {
            this.state.isNewCommentsOnTop ? this._scrollToCommentsSectionBottom() : this._scrollToCommentsSectionTop()
        }
    }

    _scrollToCommentsSectionTop() {
        this.callbacks.scrollToElementCb(this.getEl(), ScrollUtils.POSITIONS.TOP)
        this.actions.resetCommentsScrollTo()
    }

    _scrollToCommentsSectionBottom() {
        this.callbacks.scrollToElementCb(this.getEl(), ScrollUtils.POSITIONS.BOTTOM)
        this.actions.resetCommentsScrollTo()
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/comments/CommentsSection.js